export const MAIN_SECTION = 'main';
export const DETAILS_SECTION = 'details';
export const BUSINESS_PARTNER_EXPORT_ID = 'business-partner';

export const BUSINESS_PARTNER_ADDRESS_EXPORT_ID = 'business-partner-address';
export const BUSINESS_PARTNER_ADDRESS_BY_ONE_EXPORT_ID = 'business-partner-by-one-address';

export const BUSINESS_PARTNER_TITLE = 'Socios de Negocio';
export const BUSINESS_PARTNER_ADDRESS_BY_ONE_TITLE = 'Dirección del Socio de Negocio';
export const BUSINESS_PARTNER_ADDRESS_TITLE = 'Direcciones de Socios de Negocio';

/*EXPORT CLIENTE TERRITORIO*/ 
export const BUSINESS_PARTNER_TERRITORIES_EXPORT_ID = 'business-partner-territories';
export const BUSINESS_PARTNER_TERRITORIES_TITLE = 'Cliente-Territorio';

export const LOCALIZED_PROPERTIES = {
  externalKeys: 'Código',
  name: 'Nombre',
  commercialName: 'Nombre Comercial',
  NIT: 'RTN',
  DNI: 'DNI',
  companies: 'Compañia',
  addresses: 'Ubicacion',
  locationOne: 'País', 
  locationTwo: 'Departamento', 
  locationThree: 'Ciudad', 
  locationFour: 'Colonia/Distrito',
  addressesAddresses: 'Dirección',
  types: 'Tipo',
  routes: 'Territorio',
  routeArea: 'Área de Rutas',
  geolocationPoint: 'Geolocalizacion',
  routingSalesOffice: 'Oficina de Venta',
  paymentCondition: 'Condición de Pago',
  businessPartnerGroup: 'Grupo de Socio',
  businessPartnerSubGroup: 'Subgrupo de Socio',
  creditLimit: 'Límite de Crédito',
};

export const LOCALIZED_PROPERTIES_PRICE_LIST = {
  externalKeys: 'Código',
  name: 'Nombre',
  distributionChains: 'Canal de Distribución',
  ownPriceList: 'Lista de Precio',
  ownDiscountList: 'Lista de Descuento',
  ownGiftList: 'Lista de Promoción',
  alternalPriceList: 'Lista de Precios Alternativa'
};

export const LOCALIZED_PROPERTIES_ADDRESS = {
  externalKeys: 'Código',
  name: 'Nombre',
  address: 'Dirección',
  longitude: 'Longitud',
  latitude: 'Latitud',
  addressType: 'Tipo de Dirección',
  country: 'País',
  department: 'Departamento',
  city: 'Ciudad',
  district: 'Colonia/Distrito',
  isPrincipal: 'Principal'
}


export const LOCALIZED_PROPERTIES_ALL_ADDRESS = {
  externalKeys: 'Código',
  name: 'Nombre',
  code: 'Código Dirección',
  address: 'Dirección',
  longitude: 'Longitud',
  latitude: 'Latitud',
  addressType: 'Tipo de Dirección',
  country: 'País',
  department: 'Departamento',
  city: 'Ciudad',
  district: 'Colonia/Distrito',
  isPrincipal: 'Principal',
  routeCode: 'Código Ruta',
  routeName: 'Nombre Ruta',
  geolocationPointUpdate: 'Geolocalización Actualizada'
}

/*
  Para el exportar de direcciones territorio
*/ 
export const LOCALIZED_PROPERTIES_TERRITORIES = {
  externalKeys: 'Codigo_Cliente',
  name: 'Nombre_Cliente',
  DNI: 'RUC_DNI',
  territorie: 'Territorio',
  address: 'Dirección',
  addressCode:'Codigo_Direccion',
  isPrincipal:'Es_Principal',
  isPrincipalBP: 'Es_Principal_Socio',
  country: 'País',
  department: 'Departamento',
  city: 'Ciudad',
  district: 'Colonia/Distrito',
  action: 'Acción'
}